export default "__VITE_ASSET__B3HupTV2__"